module.exports = __webpack_public_path__ + "img/lacertosus_big.f6ba8bbd.png";